import React from 'react';

export default function Sandbox() {
  return null;
}
